import React from "react";
import { useParams } from "react-router-dom";
import { useUserQuery } from "../../../hooks/useUserQuery";
import { Skeleton, Card } from "antd";
import UserCreateForm from "./UserCreateForm";

const UserCreate = () => {
  const { userId } = useParams();
  const { data: user, isLoading, error } = useUserQuery(userId);

  if (isLoading && userId) {
    return <Card style={{ margin: 10 }}><Skeleton active paragraph={{ rows: 8 }} /></Card>;
  }

  if (error) {
    return <div>Error al cargar usuario: {error.message}</div>;
  }

  return <UserCreateForm user={user} userId={userId} />;
};

export default UserCreate;
